import { ApiRequestOptions, ResponseFormat } from "../constants/interfaces";

function getRequestHeaders(type: 'json' | 'form') {
  let headers: Record<string, string> = {};

  switch (type) {
    case 'json':
      headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'access-control-allow-origin': '*',
      }
      break
    case 'form':
      headers = {}
      break
    default:
      headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }
      break
  }
  return headers
}

function createQueryOrParams(object: Record<string, any> | null, type: 'params' | 'query') {
  let string = ''
  let length = Object.entries(object).length || 0
  if (type === 'query') {
    string = '?'
    Object.entries(object).forEach((item, index) => {
      string = string + item[0] + '=' + item[1]
      if (length !== index + 1) {
        string = string + '&'
      }
    })
  } else if (type === 'params') {
    string = '/'
    Object.entries(object).forEach((item, index) => {
      string = string + item[1]
      if (length !== index + 1) {
        string = string + '/'
      }
    })
  }
  return string
}

// const apiRequest = async ({
//   endUrl,
//   method = "GET",
//   headerType = 'json',

//   // Payload
//   body = null,
//   query = null,
//   params = null,

//   auth = true,
//   token = null
// }: ApiRequestOptions): Promise<ResponseFormat> => {
//   let requestHeaders = getRequestHeaders(headerType)

//   if (token) {
//     requestHeaders['Authorization'] = 'Bearer ' + token
//   } else if (auth && sessionStorage.getItem('token')) { /* Add token */
//     requestHeaders['Authorization'] = 'Bearer ' + sessionStorage.getItem('token')
//   }

//   if (params) { /* Add params */
//     endUrl = endUrl + createQueryOrParams(params, 'params')
//   }
//   if (query) { /* Add query */
//     endUrl = endUrl + createQueryOrParams(query, 'query')
//   }


//   const options: RequestInit = {
//     method,
//     headers: requestHeaders,
//     ...(body && headerType === 'json' && { body: JSON.stringify(body) })
//   };

//   try {

//     let response = await fetch(endUrl, options)

//     let contentType = response.headers.get('Content-Type');

//     let result: ResponseFormat = {};

//     if (contentType && contentType.includes('application/json')) {
//       result = await response.json();
//     } else {
//       const text = await response.text()
//       return {
//         status: true,
//         result: { text },
//         isJson: false
//       }
//     }
//     console.log(result?.status==='SUCCESS'?true:false,result)
//     const status = result?.status === "SUCCESS"?true:false;

//     if (status) {
//       /* Will modify according to api's response */
//       result = {
//         status,
//         result: result.result,
//         msg: result.msg,
//         isJson: true
//       }
//     } else {
//       result = { status, result: {}, msg: result.msg, isJson: true };
//     }

//     return result
//   } catch (e) {
//     return { status: false, result: {}, msg: e.toString(), isJson: true }
//   }
// }

const apiRequest = async ({
  endUrl,
  method = "GET",
  headerType = 'json',

  // Payload
  body = null,
  query = null,
  params = null,

  auth = true,
  token = null
}: ApiRequestOptions): Promise<ResponseFormat> => {
  let requestHeaders = getRequestHeaders(headerType);

  if (token) {
    requestHeaders['Authorization'] = 'Bearer ' + token;
  } else if (auth && sessionStorage.getItem('token')) { /* Add token */
    requestHeaders['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
  } else if (auth && localStorage.getItem('token')) { /* Add token */
    requestHeaders['Authorization'] = 'Bearer ' + localStorage.getItem('token');
  }

  if (params) { /* Add params */
    endUrl = endUrl + createQueryOrParams(params, 'params');
  }
  if (query) { /* Add query */
    endUrl = endUrl + createQueryOrParams(query, 'query');
  }

  // Prepare the options for the fetch request
  const options: RequestInit = {
    method,
    headers: requestHeaders,
    // Check if body is FormData or regular JSON
    ...(body && !(body instanceof FormData) && headerType === 'json' && { body: JSON.stringify(body) }),
    ...(body instanceof FormData && { body }) // If it's FormData, don't stringify it
  };

  // Remove 'Content-Type' header if FormData is used
  if (body instanceof FormData) {
    delete requestHeaders['Content-Type'];
  }

  try {
    let response = await fetch(endUrl, options);

    let contentType = response.headers.get('Content-Type');
    let result: ResponseFormat = {};

    if (contentType && contentType.includes('application/json')) {
      result = await response.json();
    } else {
      const text = await response.text();
      return {
        status: true,
        result: { text },
        isJson: false
      };
    }

    const status = result?.status === "SUCCESS" ? true : false;

    if (status) {
      /* Modify according to API's response */
      result = {
        status,
        result: result.result,
        msg: result.msg,
        isJson: true
      };
    } else {
      result = { status, result: {}, msg: result.msg?result?.msg:result?.error, isJson: true };
    }

    return result;
  } catch (e) {
    return { status: false, result: {}, msg: e.toString(), isJson: true };
  }
};


export {
  apiRequest
}
